// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__wEwXS","rootSuccess":"CompleteLink_rootSuccess__jDGd7","rootFailure":"CompleteLink_rootFailure__1I3_m","isDisabled":"CompleteLink_isDisabled__31GL3"};